import React from 'react'
import styled from 'styled-components'
import LoadInView from '../common/LoadInView'
import { Description, Title } from '../common/System'
import { useUpdateGetApi } from '../../hooks/useUpdate'

type propsType = {
    handleSubmit: () => void;
    isUpdating: boolean
}

const Update = (props: propsType) => {
    const {isLoading, data} = useUpdateGetApi()

  return (
    <div>
        <Title>데이터 업데이트</Title>
        <Description>구글시트에서 학문프로파일을 업데이트합니다.</Description>
        {isLoading?
            <div></div>
            :
            <Description>마지막 업데이트 일시: {data.updated_at.slice(0,19).replace('T', ' ')}</Description>}
        <LoadInView>
            <BtnWrapper>
                <Btn onClick={props.handleSubmit}>{props.isUpdating?
                    '>>> 진행중 >>>': '업데이트하기'
                }</Btn>
            </BtnWrapper>
        </LoadInView>
    </div>
  )
}

export default Update

const BtnWrapper = styled.div`
    width: 100%;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;
    // border: 1px solid #aaa;

`

const Btn = styled.button`
    width: 150px;
    height: 50px;
    background-color: #ffffff;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);

    border: none;
    border-radius: 20px;
    letter-spacing: 2.5px;

    &:hover {
        font-weight: 700;
        transition: .4s;
        font-size: 14px;
    }
`